import React from "react";
import "./style.scss";

const Fallback = () => {
	return <iframe className="iframe500" title="page500" src="https://oops.garena.com/500" frameBorder="0"></iframe>;
};

export default Fallback;
